import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import route from '../store/index'
import api from '../api/index'
// 内容
// import countryContent from './content.js'
// // 乡村
// import countryRouter from "./country.js";
// // 设置
// import setUserRouter from "./setUser";
// // 文章
// import ArticleManagement from './aticle';
// // 订单
// import CntManagementt from './order';
// // 电商
// import ECommerceServiceRouter from './ECommerceService.js';
// // 用户
// import userRouter from './uesrlist.js';
// // 仪表盘
// import instrumentsPanelRouter from './instrumentsPanel.js';

Vue.use(VueRouter)
export const routes = [
  {
    path: '/',
    name: 'Layout',
    component: () => import('../layout.vue'),
    redirect: { name: 'list' },
    hidden: true,
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import('../views/index/index.vue')
      },
      {
        path: "/blank",
        name: "blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path: '/instrumentsPanel/list',
        name: 'list',
        meta: { bread: [{ name: "仪表盘", jump: '' }, { name: "基本数据概览", jump: '' }] },
        component: () => import('../views/instrumentsPanel/list.vue')
      },
      {
        path: "/instrumentsPanel/marketList",
        name: "marketList",
        meta: { bread: [{ name: "仪表盘", jump: '' }, { name: "电商/销售数据", jump: '' }] },
        component: () => import('../views/instrumentsPanel/marketList.vue')
      },

      {
        path: "/CntManagement/tformorders/tformorders",
        name: "tformorders",
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "平台订单列表", jump: '' }] },
        component: () => import("../views/CntManagement/tformorders/tformorders.vue")
      },

      {
        path: "/CntManagement/ruralorders/ruralorders",
        name: "ruralorders",
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "乡村订单列表", jump: '' }] },
        component: () => import("../views/CntManagement/ruralorders/ruralorders.vue")
      },
      {
        path: "/CntManagement/distribution/distribution",
        name: "distribution",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "分销记录", jump: '' }] },
        component: () => import("../views/CntManagement/distribution/distribution.vue")
      },

      {
        path: "/CntManagement/commentmana/commentmana",
        name: "commentmana",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "评论管理", jump: '' }] },
        component: () => import("../views/CntManagement/commentmana/commentmana.vue")
      },
      {
        path: "/orderdetails",
        name: "orderdetails",
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "订单列表", jump: 'back' }, { name: "订单详情", jump: '' }] },
        component: () => import("../views/CntManagement/orderdetails/orderdetails.vue")
      },
      {
        path: "/detail",
        name: "detail",
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "订单列表", jump: 'back' }, { name: "订单详情", jump: '' }] },
        component: () => import("../views/CntManagement/orderdetails/detail.vue")
      },
      {
        path: "/send",
        name: "send",
        meta: { bread: [{ name: "订单/评论管理", jump: '' }, { name: "订单列表", jump: 'back' }, { name: "售后详情", jump: '' }] },
        component: () => import("../views/CntManagement/send/send.vue")
      },
      {
        path: "/management",
        name: "management",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "总后台账号管理", jump: '' }] },
        component: () => import("../views/Setup/management/management.vue")
      },
      {
        path: "/identity",
        name: "identity",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "总后台身份管理", jump: '' }] },
        component: () => import("../views/Setup/identity/identity.vue")
      },
      {
        path: "/commerce",
        name: "commerce",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "乡村电商管理员", jump: '' }] },
        component: () => import("../views/Setup/commerce/commerce.vue")
      },
      {
        path: "/Administrators",
        name: "Administrators",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "乡村管理员列表", jump: '' }] },
        component: () => import("../views/Setup/Administrators/Administrators.vue")
      },
      {
        path: "/commerce/recordsT",
        name: "recordsT",
        meta: { tabBar: true, auth: false },
        // meta: { title: "乡村电商管理员" },
        component: () => import("../views/Setup/commerce/recordsT.vue")
      },
      {
        path: "/userList",
        name: "userList",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "乡村电商分销管理", jump: '' }] },
        component: () => import("../views/Setup/userList/userList.vue")
      },
      {
        path: "/settings",
        name: "settings",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "平台设置", jump: '' }] },
        component: () => import("../views/Setup/settings/index.vue")
      },
      {
        path: "/operation",
        name: "operation",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "操作日志", jump: '' }] },
        component: () => import("../views/Setup/operation/operation.vue")
      },
      {
        path: "/routeS",
        name: "routeS",
        meta: { bread: [{ name: "设置", jump: '' }, { name: "路由管理", jump: '' }] },
        component: () => import("../views/Setup/routeS/routeManagement.vue")
      },
      {
        path: '/userListData/list',
        name: 'userListData',
        meta: { bread: [{ name: "用户列表", jump: '' }] },
        component: () => import('../views/userListData/list.vue'),
      },
      {
        path: 'userListData/audit',
        name: 'auditUserListData',
        meta: { bread: [{ name: "入驻审批", jump: '' }] },
        component: () => import('../views/userListData/audit/index.vue'),
      },
      {
        path: 'userListData/secretary',
        name: 'secretary',
        meta: { bread: [{ name: "书记入驻审批", jump: '' }] },
        component: () => import('../views/userListData/secretary/index.vue'),
      },
      {
        path: '/ECommerceService/ServiceList',
        name: 'ServiceList',
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "乡村电商服务列表", jump: '' }] },
        component: () => import('../views/ECommerceService/ServiceList/list.vue')
      },
      {
        path: "/ECommerceService/ServiceList/adminDetail",
        name: "adminDetail",
        meta: { title: "乡村管理员" },
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "乡村电商服务列表", jump: '' }, { name: "乡村电商管理员", jump: '' }] },

        component: () => import('../views/ECommerceService/ServiceList/adminDetail.vue')
      },
      {
        path: "/ECommerceService/CommodityManagement",
        name: "CommodityManagement",
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "乡村商品管理", jump: '' }] },
        component: () => import('../views/ECommerceService/CommodityManagement/list.vue')
      },
      {
        path: "/OwnershipManagement",
        name: "OwnershipManagement",
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "归属管理", jump: '' }] },
        component: () => import('../views/ECommerceService/OwnershipManagement/list.vue')
      },
      {
        path: "/OwnershipManagement/recordsT",
        name: "OwnershipManagementrecordsT",
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "归属管理", jump: '/OwnershipManagement' }, { name: "收入/结算记录", jump: '' }] },
        component: () => import("../views/ECommerceService/OwnershipManagement/recordsT.vue")
      },
      {
        path: "/CommodityAudit",
        name: "CommodityAudit",
        meta: { bread: [{ name: "乡村电商服务", jump: '' }, { name: "商品审核", jump: '' }] },
        component: () => import('../views/ECommerceService/CommodityAudit/list.vue')
      },
      {
        path: "/record",
        name: "record",
        component: () => import('../views/ECommerceService/record/record.vue')
      },
      {
        path: '/countryList/countryMessage/list',
        name: 'countryMessage',
        // meta: {bread:["乡村信息管理","乡村信息列表"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "乡村信息列表", jump: '' }] },
        component: () => import('../views/countryList/countryMessage/list.vue')
      },
      {
        path: "/countryList/demand/list",
        name: "demandList",
        // meta: {bread:["乡村信息管理","乡村申请审核(乡村/电商)"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "乡村申请审核(乡村/电商)", jump: '' }] },
        component: () => import('../views/countryList/demand/list.vue')
      },
      {
        path: "/countryList/RuralFlexibility/list",
        name: "RuralFlexibility",
        // meta: {bread:["乡村信息管理","乡村灵活用工市场"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "乡村灵活用工市场", jump: '' }] },
        component: () => import('../views/countryList/RuralFlexibility/list.vue')
      },
      {
        path: "/countryList/serviceConfiguration/list",
        name: "serviceConfiguration",
        // meta: {bread:["乡村信息管理","乡村服务功能配置"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "乡村服务功能配置", jump: '' }] },
        component: () => import('../views/countryList/serviceConfiguration/list.vue')
      },
      {
        path: "/countryList/governmentArticles/list",
        name: "governmentArticles",
        // meta: {bread:["乡村信息管理","党政文章"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "党政文章", jump: '' }] },
        component: () => import('../views/countryList/governmentArticles/list.vue')
      },
      {
        path: "/countryList/version/list",
        name: "version",
        // meta: {bread:["乡村信息管理","党政文章"] },
        meta: { bread: [{ name: "乡村信息管理", jump: '' }, { name: "版本管理", jump: '' }] },
        component: () => import('../views/countryList/version/list.vue')
      },
      {
        path: "/countryList/ServiceStation/list",
        name: "ServiceStation",
        meta: { bread: ["乡村信息管理", "服务驿站管理"] },
        // meta: {bread:[{name:"乡村信息管理",jump:''} , {name:"服务驿站管理",jump:''}]},
        component: () => import('../views/countryList/ServiceStation/list.vue')
      }, {
        path: '/ArticleManagement/aticleList/aticleList',
        name: 'aticleList',
        meta: { bread: [{ name: "文章管理", jump: '' }, { name: "文章列表", jump: '' }] },
        component: () => import('../views/ArticleManagement/aticleList/aticleList.vue')
      },
      {
        path: '/Topicsettings',
        name: 'Topicsettings',
        meta: { bread: [{ name: "文章管理", jump: '' }, { name: "文章专区管理", jump: '' }] },
        component: () => import('../views/ArticleManagement/Topicsettings/Topicsettings.vue')
      },
      {
        path: '/Topicmanagement',
        name: 'Topicmanagement',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "话题管理", jump: '' }] },
        component: () => import('../views/ArticleManagement/Topicmanagement/Topicmanagement.vue')
      },
      {
        path: '/ArticleManagement/QualityArticle/list',
        name: 'QualityArticle',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "优质文章管理", jump: '' }] },

        component: () => import('../views/ArticleManagement/QualityArticle/list.vue'),
      },
      {
        path: '/ArticleManagement/QualityArticle/add',
        name: 'addQualityArticle',
        meta: { bread: [{ name: "文章管理", jump: '' }, { name: "添加文章", jump: '' }] },

        component: () => import('../views/ArticleManagement/QualityArticle/add.vue'),
      },
      {
        path: "/Banner",
        name: "Banner",
        meta: { bread: [{ name: "内容信息管理", jump: '' }, { name: "banner管理", jump: '' }] },
        component: () => import("../views/mantiopl/Banner/Banner.vue")
      },
      {
        path: "/feedback",
        name: "feedback",
        meta: { bread: [{ name: "内容信息管理", jump: '' }, { name: "反馈建议", jump: '' }] },
        component: () => import("../views/mantiopl/feedback/feedback.vue")
      },
      {
        path: "/mantiopl/Reporting/reporting",
        name: "Reporting",
        meta: { bread: [{ name: "内容信息管理", jump: '' }, { name: "举报信息", jump: '' }] },
        component: () => import("../views/mantiopl/Reporting/reporting.vue")
      },
      {
        path: "/mantiopl/Phonebook/Phonebook",
        name: "Phonebook",
        meta: { bread: [{ name: "内容信息管理", jump: '' }, { name: "电话本设置", jump: '' }] },
        component: () => import("../views/mantiopl/Phonebook/Phonebook.vue")
      },
      {
        path: "/Platform/managementF/managementF",
        name: "managementF",
        meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "平台商品管理", jump: '' }] },
        component: () => import("../views/Platform/managementF/managementF.vue")
      },

      {
        path: "/Platform/managementF/oductediti",
        name: "oductediti",
        // meta:{tabBar:true,auth:false},
        // meta: { bread:["平台电商管理","平台商品管理"] },
        // meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "平台商品管理", jump: '' }, { name: "编辑", jump: '' }] },

        component: () => import("../views/Platform/managementF/oductediti.vue")
      },

      {
        path: "/Platform/fication/fication",
        name: "fication",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "分类管理", jump: '' }] },
        component: () => import("../views/Platform/fication/fication.vue")
      },

      {
        path: "/Platform/belmanag/belmanag",
        name: "belmanag",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "标签管理", jump: '' }] },
        component: () => import("../views/Platform/belmanag/belmanag.vue")
      },

      {
        path: "/Platform/logistics/logistics",
        name: "logistics",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "物流设置", jump: '' }] },
        component: () => import("../views/Platform/logistics/logistics.vue")
      },

      {
        path: "/Platform/Zone/Zone",
        name: "Zone",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "平台电商管理", jump: '' }, { name: "专区管理", jump: '' }] },
        component: () => import("../views/Platform/Zone/Zone.vue")
      },
      {
        path: "/management/passwords",
        name: "passwords",
        // meta:{tabBar:true,auth:false},
        // meta: { title: "路由管理" },
        component: () => import("../views/Setup/management/passwords.vue")
      },
      {
        path: "/financeAdmin/withdrawList",
        name: "withdrawList",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "财务管理", jump: '' }, { name: "提现审核", jump: '' }] },
        component: () => import("../views/financeAdmin/withdrawList.vue")
      },
      {
        path: "/financeAdmin/waterBill",
        name: "waterBill",
        // meta:{tabBar:true,auth:false},
        meta: { bread: [{ name: "财务管理", jump: '' }, { name: "商品流水账单", jump: '' }] },
        component: () => import("../views/financeAdmin/waterBill.vue")
      },


      {
        path: "/AgriculturalConsulting/AgriculturalConsulting/list",
        name: 'AgriculturalConsulting',
        meta: { bread: [{ name: "农业资讯管理", jump: '' }, { name: "农业资讯管理", jump: '' }] },
        component: () => import("../views/AgriculturalConsulting/AgriculturalConsulting/list.vue")
      },
      {
        path: '/topUpOrder',
        name: 'topUpOrder',
        meta: { bread: [{ name: "充值订单管理", jump: '' }] },
        component: () => import('../views/topUpOrder/list.vue'),
      },
      {
        path: '/contentManagement/inventory',
        name: 'inventory',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "事务清单", jump: '' }] },
        component: () => import('../views/contentManagement/inventory/index.vue')

      },

      {
        path: '/contentManagement/party',
        name: 'party',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "服务日志", jump: '' }] },
        component: () => import('../views/contentManagement/party/index.vue')

      }, {
        path: '/contentManagement/Disclosure',
        name: 'Disclosure',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "三务公开", jump: '' }] },
        component: () => import('../views/contentManagement/Disclosure/index.vue')

      },

      {
        path: '/contentManagement/secretary',
        name: 'secretary',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "公开信", jump: '' }] },
        component: () => import('../views/contentManagement/secretary/index.vue')

      }, {
        path: '/contentManagement/villager',
        name: 'villager',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "村民办事", jump: '' }] },
        component: () => import('../views/contentManagement/villager/index.vue')

      },

      {
        path: '/contentManagement/villagerState',
        name: 'villagerState',
        meta: { bread: [{ name: "内容管理", jump: '' }, { name: "乡村动态", jump: '' }] },
        component: () => import('../views/contentManagement/villagerState/index.vue')

      },
      {
        path: '/Genealogy/genealogyList',
        name: 'genealogyList',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "族谱文化列表", jump: '' }] },
        component: () => import('../views/Genealogy/genealogyList/list.vue')


      },
      {
        path: '/Genealogy/Configuration',
        name: 'Configuration',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "家谱数据配置", jump: '' }] },
        component: () => import('../views/Genealogy/Configuration/list.vue')

      },
      {
        path: '/Genealogy/entering',
        name: 'entering',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "录入谱系", jump: '' }] },
        component: () => import('../views/Genealogy/entering/list.vue')

      },
      {
        path: '/Genealogy/surname',
        name: 'surname',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "中华姓氏通谱列表", jump: '' }] },
        component: () => import('../views/Genealogy/surname/list.vue')

      },
      {
        path: '/Genealogy/saveSurname',
        name: 'saveSurname',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "中华姓氏通谱列表", jump: '' }, { name: "已保存姓氏列表", jump: '' }] },
        component: () => import('../views/Genealogy/surname/saveSurname/list.vue')

      },
      {
        path: '/Genealogy/addSurname',
        name: 'addSurname',
        meta: { bread: [{ name: "族谱文化管理", jump: '' }, { name: "中华姓氏通谱列表", jump: '' }, { name: "新增姓氏", jump: '' }] },
        component: () => import('../views/Genealogy/surname/add.vue')

      },
      {
        path: '/tourismculture/homereview',
        name: 'homereview',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "民宿审核", jump: '' }] },
        component: () => import('../views/tourismculture/homereview.vue')

      },
      {
        path: '/tourismculture/homestaymanag',
        name: 'homestaymanag',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "民宿管理", jump: '' }] },
        component: () => import('../views/tourismculture/homestaymanag.vue')

      },
      {
        path: '/tourismculture/popularattra',
        name: 'popularattra',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "热门景点列表", jump: '' }] },
        component: () => import('../views/tourismculture/popularattra.vue')

      },
      {
        path: '/tourismculture/popularattractions/list',
        name: 'listpopularattractions',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建热门景点", jump: '' }] },
        component: () => import('../views/tourismculture/popularattractions/list.vue')
      },
      {
        path: '/tourismculture/recommend',
        name: 'recommend',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "推荐路线列表", jump: '' }] },
        component: () => import('../views/tourismculture/recommend.vue')

      },
      {
        path: '/tourismculture/recommendS/list',
        name: 'listrecommendS',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建推荐路线", jump: '' }] },
        component: () => import('../views/tourismculture/recommendS/list.vue')
      },
      {
        path: '/tourismculture/playingwith',
        name: 'playingwith',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "玩什么文章列表", jump: '' }] },
        component: () => import('../views/tourismculture/playingwith.vue')

      },
      {
        path: '/tourismculture/playingwithS/list',
        name: 'listplayingwithS',
        meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建文章", jump: '' }] },
        component: () => import('../views/tourismculture/playingwithS/list.vue')
      },
      {
        path: '/integral/classify',
        name: 'classifyList',
        meta: { bread: [{ name: "积分管理", jump: '' }, { name: "积分事项分类管理", jump: '' }] },
        component: () => import('../views/integral/classify/list.vue')
      },
      {
        path: '/robotManagement/interactionStrategy',
        name: 'interactionStrategy',
        meta: { bread: [{ name: "机器人管理", jump: '' }, { name: "人机互动策略", jump: '' }] },
        component: () => import('../views/robotManagement/interactionStrategy/list.vue')
      },
      {
        path: '/robotManagement/interactionTask',
        name: 'interactionTask',
        meta: { bread: [{ name: "机器人管理", jump: '' }, { name: "人机互动任务", jump: '' }] },
        component: () => import('../views/robotManagement/interactionTask/list.vue')
      },
      {
        path: '/robotManagement/commentPlan',
        name: 'commentPlan',
        meta: { bread: [{ name: "机器人管理", jump: '' }, { name: "评论互动方案", jump: '' }] },
        component: () => import('../views/robotManagement/commentPlan/list.vue')
      },
      {
        path: '/robotManagement/commentTask',
        name: 'commentTask',
        meta: { bread: [{ name: "机器人管理", jump: '' }, { name: "评论互动任务", jump: '' }] },
        component: () => import('../views/robotManagement/commentTask/list.vue')
      },

      // belmanag
      // setUserRouter,
      // instrumentsPanelRouter,
      // userRouter,
    ],

    // userRouter,
    // countryRouter,
    // CntManagementt,
    // ArticleManagement,
    // countryContent,

    // ECommerceServiceRouter,
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../login.vue')
  },

]
const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to, from, next) => {
  // let arr = JSON.parse(localStorage.getItem('routeList'))
  // let routeID =localStorage.getItem('rouId')
  let page = to.path.split('/')
  let toPage = page[2] == 'productList' ? '/production/productList' : to.path
  let a = [true]

  if (to.meta.bread && to.meta.bread.length==2) {
    document.title = to.meta.bread[1].name + ' | 合美总管理台'
  }else if(to.meta.bread && to.meta.bread.length==1) {
    document.title = to.meta.bread[0].name + ' | 合美总管理台'
  }
  else {
    document.title = '合美乡村管理系统 | 合美总管理台'
  }
  //   // if(arr) {
  //   //   console.log(arr,'arr')
  //   //   arr.forEach(e =>{
  //   //     if(!e.childMenus) return
  //       // a.push(e.childMenus.some(obj =>{

  //         // 存在路由时存储按钮
  //         // if(obj.jump === toPage) {
  //           // api.account.adminJurisdiction().then(res => {
  //           //   let data = res.data.data
  //           //   data.forEach(child =>{
  //           //     if(Number(child.id) === Number(routeID)) {
  //           //       if(obj.childMenus) {
  //           //         let childData = child.roule.split(',')
  //           //         let control = []
  //           //         obj.childMenus.forEach(son =>{
  //           //           childData.forEach(sonCd =>{
  //           //             if(Number(sonCd) === son.id) {
  //           //               control.push(son.jump)
  //           //             }
  //           //           })
  //           //         })
  //           //         route.commit('savePageButton', control)
  //           //       }
  //           //     }
  //           //   })
  //           // })
  //         // }
  //         // return obj.jump === toPage
  // }
  // ))

  //   //   })
  //   // }
  // if(
  //     a.includes(true) || toPage === '/index' ||
  //     toPage === '/Login' || toPage === '/blank' ||
  //     toPage === '/production/productListDialog' ||
  //     toPage === '/orderManagement/productOrderDetail'
  //     )
  //   {
  next()
  // }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js